module.exports = __webpack_public_path__ + "10e595905a4218cadd7ffd19a890528b.png";